
export const BRANCH_DETAIL_SUCCESS = 'BRANCH_DETAIL_SUCCESS';
export const BRANCH_DETAIL_FAILURE = 'BRANCH_DETAIL_FAILURE';
